import { useState } from "react";
import { FaUserCircle } from "react-icons/fa";
import { MenuOptions } from "components/menu-option";
import { getSession } from "utils/auth";
import { DashboardNavbarContainer } from "./dashboard-navbar.style";

const DashboardNavbar = () => {
   const { logout } = getSession();
   const [_isOpen, setIsOpen] = useState(false);

   return (
      <DashboardNavbarContainer>
         <div>
            <MenuOptions
               menuButton={
                  <FaUserCircle
                     style={{ cursor: "pointer", fontSize: "30px" }}
                     onClick={() => setIsOpen(true)}
                  />
               }
               onClose={() => setIsOpen(false)}
               options={["Logout"]}
               optionsFns={[logout]}
            />
         </div>
      </DashboardNavbarContainer>
   );
};

export { DashboardNavbar };
